import React, {FC} from 'react';
import './style.scss';
import {pathSuite} from "../../constants";
import BaseButton from "../form/Button";
import likeMix from "../../assets/img/mixes-list/like-mix.svg";
import nonLikeMix from "../../assets/img/mixes-list/non-like-mix.svg";
import favoriteMix from "../../assets/img/mixes-list/favorite__mix.svg";
import {useSelector} from "react-redux";
import Img from "react-image";
import noMix from "../../assets/img/no__mix.png";

interface IMixesCard {
    clickHandler?: () => any,
    imageUrl: string,
    name: string,
    isLiked: boolean,
    likeCount: number,
    id: number
}

const MixesCard: FC<IMixesCard> = ({
                                       clickHandler,
                                       imageUrl,
                                       name,
                                       isLiked,
                                       likeCount,
                                       id
                                   }) => {
    const favoriteMixes = useSelector<any, any>(state => state.favorite.favoriteMixes);
    const isFavoriteMix = !!favoriteMixes.find((item: any) => item.id === id);

    return (
        <div className="mixes-list__card"
             onClick={clickHandler}
        >
            <Img
                className="mixes-list__card-img"
                src={[pathSuite + imageUrl, noMix]}
                loader={<Img
                    src={noMix}
                    className="mixes-list__card-img"
                    alt="Preloader"/>}
            />
            <div className="mixes-list__card-container">
                <div className="mixes-list__title">
                    {
                        name.length > 33
                            ? name
                                .slice(0, 33)
                            + "..."
                            : name
                    }
                </div>
                <div className="mixes-list__card-footer">
                    <div className="mixes-list__button">
                        <BaseButton
                            withBorderRadius
                            isMixesListButton
                            isGreenButton
                        >
                            <span className="mixes-list__button-text">
                                Попробовать
                            </span>
                        </BaseButton>
                    </div>
                    <div className="mixes-list__marks">
                        {
                            isFavoriteMix
                                ? <img
                                    className="mixes-list__favorite"
                                    src={favoriteMix}
                                    alt="favorite"
                                />
                                : null
                        }
                        <div className="mixes-list__like">
                            <div>
                                <img
                                    src={
                                        isLiked
                                            ? likeMix
                                            : nonLikeMix}
                                    alt="Card"
                                />
                            </div>
                            <div className="mixes-list__like-count">
                                {likeCount}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MixesCard;
